let en = {
  login: {
    login: "login",
  },
  index: {
    hello: "hello world！",
    hi: "another hello world!",
    signin: "sign in",
    Home: "Home",
    Mine: "Me",
    search: "Search course/Training plan/Study program",
    appstoryInfo:
      "Offline download is supported for clearer and more smooth images.",
    downloadApp: "Download",
    openApp: "Open APP",
    useWeb: "Use Web to learn",
  },
  // 365课程
  yearCourse: {
    learningToday: "Learning today",
    historyCourses: "Previous Courses",
    credit: "",
    studyCredit: "Credit",
    lengthOfStudy: "Used time",
    dailyReflection: "Daily Reflection",
    hotPosts: "Hot posts",
    latestPosts: "Latest posts",
    forum: "Forum",
    more: "More",
    lookMore: "More",
    lookMore2: "Look More",
    learningTopics: "Learning topics",
    details: "Details",
    introduction: "Introduction",
    pushedToday: "Content pushed today",
    pushedOnTheDay: "The content pushed on the day",
    yourThoughts:
      "Combine the questions in the course and talk about your thoughts",
    save: "Save",
    submit: "Submit",
    share: "Share",
    postToCommunity: "Publish to community",
    submitSuccess: "Submitted successfully",
    edit: "Edit",
    yourComment: "Please enter your comment (at least 10 words)",
    commentList: "List",
    othersComment: "Show content from others",
    back: "Back",
    previousPage: "Previous page",
    nextPage: "Next page",
    close: "Close",
    open: "Details",
    mySubmission: "My submission",
    nullDailyReflection: "You haven't publish your daily reflection,",
    nullDailyReflection2: "talk about your thoughts with course content~",
    delete: "Delete",
    post: "Post",
    commentHint: "Please enter the content of the post",
    postReply: "Reply",
    replys: "Replys",
    reply: "Reply",
    document: "Document",
    read: "Read",
    article: "Article",
    warningHint: "The content cannot be less than 10 words",
    PostContent: "Reply fill in the comment box",
    dailyReflectionDetails: "Daily Reflection Details",
    nullContents: "No contents",
    deleteComment: "Are you sure to delete the comment?",
    deleteReply: "Are you sure to delete the reply?",
    searchContent: "Search content title",
    public: "Public",
    onlyMe: "Only me",
    photo: "Photo",
    video: "Video",
    pushCourse: "Push course",
    history: "Learning history",
    missedCourses: "Missed courses",
    community: "Community",
    writeContent: "Write content",
    showOther: "View content from other students",
    studyThem: "Topics of study",
    contentDetails: "Content details",
    contentType: "Content type",
    completionTime: "Completion time",
    completedCourse: "Completed Course",
    sharedDaily: "Shared daily reflection",
    ofPushCourse: "Push course",
    unpushHint: "The course will be pushed to you soon~",
    uploadHint1: "You can upload up to 3 images or 1 video at a time!",
    uploadHint2: "Supports JPG, PNG images!",
    uploadHint3:
      "You can upload up to 3 images at a time and each image size cannot exceed 5M!",
    uploadHint4: "Video files up to 100M supported！",
    uploadHint5: "You can upload up to 3 images or 1 video at a time!",
    pinToTop: "TOP",
    postingInProgress: "Posting in progress, please refresh later",
    deleteAsk: "Posting in progress, are you sure you want to delete?",
    cancel: "Cancel",
    unfinishedCourses: "No unfinished courses at the moment",
    fileConversion:
      "File conversion in progress, please refresh the page later",
    otherReflection: "His/Her daily reflection",
    studyTime: "Duration(min.)",
    studyIntegral2: "Points",
    footmark: "Footmark",
  },
  // p2p学习
  P2PStudy: {
    learningPath: "Learning path",
    student: "Student list",
    acivity: "Mine",
    start: "Start",
    question: "Question",
    suggestTime: "Recommended Deadline：",
    optional: "Optional",
    valid: "Valid",
    until: "-",
  },
  // 登录
  loginPage: {
    login: "Login",
    forget: "Forgot password?",
    namePlaceholder: "Login Count",
    passPlaceholder: "Password",
    nullName: `Name can't be empty`,
    nullPassword: `Password cannot be empty.`,
    experience: "Register for a try",
    version: "Current Version:",
    captchaTitle: "Enter picture verification code",
    captchaImgRefresh: "Unclear. Get another one",
    captchaError: "Verification code error",
    captchaSure: "Confirm",
  },
  // 忘记密码
  forgetPassPage: {
    title: "Forgot Password",
    domainPlaceholder: "Platform domain address",
    namePlaceholder: "Enter your username",
    nextStep: "Next Step",
    domainError: `No phone number or username doesn't exist. Please contact the administrator to reset your password`,
    nullDomain: "please complete platform information",
    codePlaceholder: "please enter verification code",
    getVerificationCode: "Obtain the verification code",
    newPaswPlaceholder: "New Password",
    confirmPaswPlaceholder: "Confirm Password",
    resetPasswordBtn: "Reset your password",
    paswInconsistent: "Your passwords do not match, please enter again.",
    paswRange: "Your password must be 8-32 characters in length.",
    resetIsNull: "Password cannot be empty.",
    send: "send to",
    sendEmail: "send to",
    clickFind: "Click to retrieve",
    findMethod: "Retrieve method",
    mobileFind: "Retrieve by binding mobile phone number",
    emailFind: "Retrieve by binding email",
    friendTip: "Tips",
    info1: "When the account is",
    info2: "not bound ",
    info3:
      "to the mobile phone number and email address, the password retrieval function cannot be used. If you encounter this problem, please contact the administrator to reset the password manually.",
    text2: "bound",
    text3:
      "with a mobile phone number or email address, you can log in directly using the phone number/email address.",
    emailPsd: "Find your password by E-mail",
    finished: "Done",
  },
  // 到期啦
  expiringPage: {
    pageTitle: "Due",
    timeUnit: "days",
    noData: "No Data~",
  },
  // 直播
  livingPage: {
    pageTitle: "Live",
    coverOverHint: "Live session is over",
    notStart: "Live Broadcast",
    onLive: "On Live",
    duringPlayback: "Replaying",
    isOver: "Finished",
    lecturer: "Instructor",
    broadcastTime: "Time passed",
    theAirtime: "Start time",
    playbackTime: "Replay time",
    endTime: "End time",
    courseDescription: "About the instructor",
    introduction: "Introduction",
    untime: "Playback session is not started yet",
    uncomplete: "Recorded livestream session is not ready",
  },
  // 账号设置
  accountSet: {
    title: "Account",
    setPhoto: "Change Photo",
    modifyPasw: "Change Password",
    modifyEmail: "Change Email",
    modifyPhone: "Change Mobile",
    oldPaswPlaceholder: "Original Password",
    nullOldPasw: "Old password is required",
    emailPlaceholder: "Please fill in email",
    nullEmail: "Please fill in your email address",
    emailError: "Please fill in the correct and valid email address",
    phonePlaceholder: "Enter your mobile phone number",
    phoneNumberError: "Please enter the correct phone number",
    notBound: "Unbounded",
    saveBtn: "Save",
    modifySuccess: "Change success",
    modifyError: "fail to edit",
    choose: "choose a photo",
  },
  // 知识汇
  knowledgePage: {
    title: "Knowledge",
    menuAll: "All",
    allCategories: "All Categories",
    newest: "Latest Release",
    host: "Most Popular",
    favorites: "Most Favorable",
    notPreview: "Not Supported",
    published: "Published on:",
    noData: "No data",
    moreComment: "More comments",
    writeComment: "Write a comment",
    detailTitle1: "Article",
    detailTitle3: "Viedo",
    detailTitle2: "Documents",
    placeholder: "Reply@Andy Edaward",
    textArea: "Please leave your comments",
    sendBtn: "Send",
    submitBtn: "Submit comments",
    commentState: "Comment successful",
    commentError: "enter your comment here ( 512+ words)",
    commentTitle1: "Comments",
    commentTitle2: "Comments",
    commentTitle3: "Comment",
    replies: "Replies",
    loadFinish: "Loaded up",
  },
  // 学习轨迹
  studyHistory: {
    title: "Study Trace",
    cycleHint: "Learning record within the last 30 days",
    studyType1: "Online Course",
    studyType2: "Independent Exam",
    studyType3: "Assignment",
    studyType4: "Extended learning",
    studyType5: "Face-to-face",
    studyType6: "Case Analysis",
    studyType7: "Reflection",
    studyType8: "Questionnaire",
    studyType9: "Live Class",
    ofPlan: "Plan",
    ofProject: "Project",
    onlyPC: "PC Olny",
    isOverdue: "Expired",
    continue: "Continue",
  },
  // 意见反馈
  feedback: {
    title: "Feedback",
    navBar1: "Training Program Problem",
    navBar2: "Platform Problem",
    navBar3: "Course Problem",
    navBar4: "Product Suggestion",
    contact: "Contact us",
    name: "Name",
    namePlaceholder: "Please fill in your name",
    email: "Email",
    emailPlaceholder: "Please fill in your email address",
    tel: "Phone",
    telPlaceholder: "Please fill in telephone number",
    textPlaceholder: "Please fill in your feedback",
    submitBtn: "Submit",
    submitSuccess: "Submit success",
    call: "Our administrative team will contact you ASAP,",
    calls: "You can also call:",
  },
  // 查报表
  statement: {
    title: "Study Data",
    weeklyStudy: "Weekly Learning Time",
    finishCourse: "Course Completed",
    projectCredit: "Project Credits Obtained",
    compulsory: "Compulsory Credits Obtained",
    elective: "Optional Credits Obtained",
    initiateTopic: "Posted Topic",
    replyTopic: "Replied",
    minutes: "Minute",
    numberOf: "Time ",
    credits: "Credit ",
    courses: "Course ",
    aimsTitle: "Target Credits",
    startTime: "Start Time:",
    endTime: "End Time:",
    compulsoryNum: "Required Credits Earned",
    electiveNum: "Optional Credits Earned",
    targetNum: "Required Credits Earned",
    creditNum: "Earn Credits",
  },
  // 独立考试
  independentTest: {
    description: "Description",
    totalScore: "Total Points",
    passScore: "Pass Points",
    duration: "Duration",
    tested: "Tested / Total",
    noTests: "You have not taken any test.",
    readOver: "Checking soon...",
    theirPapers: "Submit time:",
    score: "Points",
    gotIt: "Correct answers",
    allProblems: "Ques.Num",
    durations: "Used time",
    pass: "PASSED",
    noPass: "FAILED",
    checkTest: "View test paper",
    startTest: "Start exam",
    submitBtn: "Submit",
    lastQest: "Back",
    nextQest: "Next",
    countDown: "Countdown",
    timeHint: "Time is up",
    qestType1: "Single Choice",
    qestType2: "Multiple Choice",
    qestType3: "Ture or False",
    qestType4: "Q & A",
    qestType5: "Fill in the blanks",
    qestType6: "Drag&Drop-Single Choice",
    qestType7: "Drag&Drop-Multiple Choice",
    qestType8: "Fill in the blanks",
    qestType9: "Multi-line true or false",
    qestType0: "Quiz",
    placeholder: "Input here...",
    confirmSubmit: "Commit",
    answer: "Please key in my answer.",
    detail: "detail",
    correct: "true",
    wrong: "false",
  },
  // 小测验
  examPage: {
    submit: "Submit",
    correct: "Correct",
    wrong: "Wrong",
    closeFeedback: "Turn off test feedback",
    openFeedback: "Open test feedback",
    otherSelect: `Check my classmates' choices`,
    checkOther: `Check my classmates' answers`,
    finish: "Finish",
    parsing: "Feedback:",
    reference: "Reference",
    checkAccuracy: "Check the accuracy of each question.",
    answerFeedback: "Feedback",
    seconds: "",
    correctlv: "Check the accuracy of each question:",
    fillIn: "Blank Filling",
    first: "Question 1",
    second: "Question 2",
    beforeSubmit: "Please submit after finishing all questions.",
    close: "Turn off the evaluation feedback.",
    open: "Turn on the evaluation feedback.",
  },
  // 积分
  integral: {
    title: "Points",
    integralRule: "Points Rules",
    integralDetail: "Points details",
    bonus: "Points",
    needUpgrade: "Need points for upgrade",
    getIntegral: "How to get points?",
    added: "Extra",
    score: "Points",
    allScore: "Overall Points",
    projectScore: "Points for Tasks",
  },

  // 公用的一些提示
  public: {
    Tip: "No relevant data available",
    HtmlNodata: "No more data~",
    DataError: "Data Error",
    RequestError: "Request Error",
    Previous: "Previous",
    Next: "Next",
    more: "more >",
    RequiredPlan: "Compulsory Plan",
    OptionalPlan: "Elective Plan",
    seconds: "",
    study: "Study reminder",
    click: "Please click any part of the screen",
    konw: "I know",
    login: "Login",
    index: "Index",
    usercenter: "User Center",
    feedback: "Feedback",
    language: "Language Setting",
    account: "Account",
    emial: "Change E-mail",
    password: "Change Password",
    phone: "Change Mobile",
    livelist: "Live list",
    live: "Live",
    Course_Center: "Optional Courses",
    Training_Plan: "Training plan",
    Quiz: "Quiz",
    Online_Course: "Online Course",
    Questionaire: "Questionaire",
    In_Classroom_Information: "In-Classroom Information",
    Evaluate_the_instructor: "Evaluate the instructor",
    Assignment_BBS: "Assignment Display",
    Assignment_Details: "Assignment Detail",
    Column: "Column Video",
    Independent_test: "Independent Test",
    Content_Center: "Knowledge",
    Students_Comments: "Students Comments",
    fav: "My Favorites",
    Study_Camp: "Study Camp",
    Program: "Program",
    plan: "Training plan",
    case: "Case analysis",
    assignment: "Assignment",
    video: "Video preview",
    file: "File",
    Illustration: "Image & text preview",
    Extended_Reading: "Extended learning",
    signing_first: "Signing-in pop-up",
    siging_second: "Daily Tracker",
    siging_third: "Daily Tracker",
    siging_forth: "Signing in report",
    try_first: "Trial questionaire",
    try_second: "Trial registration",
    try_third: "Trial registration info",
    service: "Service Protocols",
    message: "Message",
    forget: "Forgot password ",
    dated: "Due",
    lessTen1: "Your reply should contain at least 10 words!",
    lessTen2: "Your reply should contain at least 10 words!",
    lessTen3: "Your reply should contain at least 10 words!",
    lessTen4: "Your reply should contain at least 10 words!",
    pullRefresh: "Pull to refresh",
    releaseRefresh: "Release to refresh",
    loadtip: "Loading…",
    courseInformation: "Course information",
    view: "View",
    allInformation: "All",
  },
  // 学习营
  learningCamp: {
    studycamp: "Study Camp",
    RequiredPlan: "Compulsory Plan",
    OptionalPlan: "Elective Plan",
    Program: "Program",
    All: "All",
    AllType: "All Type",
    // 培训计划
    TrainingPlan: "Training Plan",
    Learningduration: "Time：",
    Downloadcertification: "Download certification",
    Canwatch: "Can watch",
    minutes: "minutes",
    Onlinecourse: "Online Course",
    studiedhours: "Used time：",
    Credits: "Credits",
    fen: "",
    Study: "Study",
    Exam: "Exam",
    Singin: "Sing in",
    Drill: "Practical Tool",
    Exam1: "Exam",
    Taketheexam: "Take the exam",
    Assignment: "Assignment",
    SubmitAssignment: "Submit Assignment",
    Checkingsoon: "Checking soon",
    Questionnaire: "Questionnaire",
    FillinQuestionaire: "Fill in Questionaire",
    Offlinecourse: "Onsite Training",
    Courseduration: "Course duration",
    Coursedetails: "Course details",
    ExpandingReading: "Extended learning",
    HaveRead: "Study",
    StartReading: "Study",
    Live: "Live",
    CaseAnalysis: "Case Analysis",
    StartAnalying: "Start Analying",
    Reflection: "Reflection",
    Thistaskgainsyou: "This task gains you",
    Writemyrelection: "Write my relection",
    Suggestedcompletiontime: "Suggested completion time", // 暂无
    OnlyPC: "Only available on computers",
    NoStudyProgram: "No study program",
    TestsAvailableAfterStudiesFinished:
      "Tests available after studies finished",
    ResourcesLocked: "Resources locked & not available for study!",
    ResourcesExpired: "Resources have expired!",
    StudyTimeNotReached: "Study time not reached",
    UnlockTheSigning:
      "Unlock the signing-in function after you complete the course!",
    TodayTaskCompleted: "Today's signing in task completed",
    SigningInHasExpired: "Signing in has expired",
    completed:
      "You can get the certificate once you complete the entire course",
    unlock: "Resource unlocked! Please fill in the trial info first.",
    studyPlan: "Study Plan",
    noData: "No Data~",
    EffectiveTime: "Effective time",
    download: "download",
    certificate: "Certificate",
  },
  // 收藏
  collect: {
    pushCourse: "Push Couse",
    community: "Community",
    dailyReflection: "Daily Reflection",
    Favorites: "My Favorites",
    TrainingPlan: "Training Plan",
    Program: "Program",
    LearningResources: "Learning Resources",
    Contentcenter: "Knowledge",
    Live: "Live",
    SpecialColumn: "Special Column",
    Post: "Post",
    Homepage: "Homepage",
    MyStudy: "MyStudy",
    Courses: "Courses",
    Knowledge: "Knowledge",
    Due: "Due",
    Tip: "No relevant data available",
    HtmlNodata: "No more data~",
    Online: "Online",
    InClassroom: "In-classroom",
    Delete: "Delete",
    CollectSuccess: "Collect Success",
    CollectCancle: "Collect Cancle",
    DataError: "Data Error",
    RequestError: "Request Error",

    // 学习项目
    include: "include",
    ge: " ",
    stages: "stages",

    // 学习资源
    OnlineCourse: "Online Course",
    Reflection: "Reflection",
    IndependentExam: "Independent Exam",
    Questionnaire: "Questionnaire",
    Assignment: "Assignment",
    CaseAnalysis: "Case Analysis",
    ExpandingReading: "Extended learning",
    Facetoface: "Face-to-face",

    // 知识汇
    Postedat: "Published on",
    Previewunsupported: "Zip files are currently not available on mobiles.",

    // 直播
    days: "days",
    hours: "hours",
    minutes: "minutes",
    Livesessionisover: "Live session is over",
    Instructor: "Instructor",
    LiveDuration: "Live Duration",
    Starttime: "Start time",
    Replaytime: "Replay time",
    EndTime: "End Time",
    OnLive: "On Live",
    Livebroadcast: "Live broadcast",
    Replaying: "Replaying",
    Finished: "Finished",
  },
  threeState: {
    Finished: "Finished",
    Incomplete: "Undone",
    Expired: "Expired",
    left: "Left ",
    days: " days",
  },
  // 个人中心
  usercenter: {
    Credits: "Credit",
    Bonus: "Points",
    History: "Study Trace",
    Signin: "Sign in",
    MyReport: "Report Center",
    Favorites: "My Favorites",
    Setting: "Setting",
    scoreList: "Points List",
  },
  // 设置
  setting: {
    setting: "Setting",
    feedback: "Feedback",
    language: "Language",
    exit: "Log Out",
    save: "Save",
    chinese: "Chinese",
    english: "English",
    LogOut: "Logged Out",
  },
  // 案例分析
  case: {
    Nameofcase: "Name of case",
    CaseDescription: "Case Description",
    NoDescription: "No Description ~",
    NoComments: "No Comments ~",
    NoAnswer: "No Answer ~",
    AttachmentPreview: "Attachment Preview",
    Previewunsupported:
      "Zip files are currently not available on mobiles, please check out on your computer.",
    Youranswer: "My Answer",
    Inputhere: "Input here...",
    Submit: "Submit",
    Edit: "Edit",
    Checkingsoon: "Checking soon",
    PassScore: "Pass Points",
    Score: "Points",
    Comments: "Comments",
    Uploadunsupported:
      "Uploading is currently unsupported. Please log in and operate on your computer.",
    UploadAttachment: "Upload Attachment",
    fen: " ",
    SubmitSuccess: "Submit Success",
    SubmitFail: "Submit Fail",
    AnswerCannotBeEmpty: "Answer Cannot Be Empty～",
    Exceedingtheupperlimitofthenumberofwords:
      "Exceeding the upper limit of the number of words～",
    IllegalCharacter: "Illegal Character～",
    Browseonthecomputer: "Please browse on the computer",
    // media_preivew
    Video: "Video",
    // file_preview
    Documents: "Documents",
  },
  // 拓展阅读
  reading: {
    Documents: "Documents",
    Video: "Video",
    Article: "Article",
    Package: "Package",
  },
  // 作业
  homework: {
    Name: "Name",
    Descriptionofassignment: "Assignment description",
    NoDescription: "No Description~",
    NoComments: "No Comments ~",
    NoAnswer: "No Answer~",
    AttachmentPreview: "Attachment Preview",
    Previewunsupported:
      "Zip files are currently not available on mobiles, please check out on your computer.",
    Youranswer: "My Answer",
    Inputhere: "Input here...",
    Submit: "Submit",
    Edit: "Edit",
    Checkingsoon: "Checking soon",
    PassScore: "Pass Points",
    Score: "Points",
    Comments: "Comments",
    Uploadunsupported:
      "Uploading is currently unsupported. Please log in and operate on your computer.",
    UploadAttachment: "Upload Attachment",
    fen: " ",
    SubmitSuccess: "Submit Success",
    SubmitFail: "Submit Fail",
    AnswerCannotBeEmpty: "Answer Cannot Be Empty～",
    Exceedingtheupperlimitofthenumberofwords:
      "Exceeding the upper limit of the number of words～",
    Limit3000: "Content length cannot exceed 3000 characters",
    IllegalCharacter: "Illegal Character～",
    Browseonthecomputer: "Please browse on the computer",
  },
  daka: {
    DailyTracker0: "Daily Tracker",
    SearchKey: "",
    Ongoing: "Ongoing",
    End: "End",
    All: "All",
    Project: "Project",
    PeriodofValidity: "Period of Validity",
    afterinitiated: "Signing in period counts after initiated",
    Signedintoday: "Signed in",
    Signedinthisweek: "Signed in this week",
    Pleasechoosea: "Please choosea type for signing in",
    Thisitemiscompulsory: "This item is compulsory",
    Checkallrecords: "Check all records",
    Signin: "Sign in",
    Turnonthetracker: "Turn on the tracker",
    records: "records",
    day: "day",
    wk: "wk.",
    WeeklyTracker: "Weekly Tracker",
    DailyTracker: "Daily Tracker",
    DontShowAgain: "I understand the above reminder. Don't show it again.",
    Successfulsigningin: "Successful signing in!",
    Makeprogresseveryday: "Make progress every day! Keep on!",
    SigninReport: "Signing in report",
    StudentName: "Student Name",
    SigninginPeriod: "Signing in Period",
    RequiredSigninginTime: "Required Signing in Time",
    CompletedSigninginTime: "Completed Signing in Time",
    TrackerTime: "Tracker Time",
    No: "No",
    Signingin: "Signing in:",
  },
  // 搜索
  search: {
    hotTags: "Hot tags",
    studyResources: "Study Resources",
    trainPlan: "Training Plan",
    courseCenter: "Optional Courses",
    program: "Program",
    contentCenter: "Knowledge",
    searchHis: "Search history",
    clearHis: "Clear search history",
    search: "search",
    onlineCourse: "Online Course",
    reflection: "Reflection",
    onsiteTraining: "Onsite Training",
    independentExam: "Independent Exam",
    queationaire: "Queationaire",
    assignment: "Assignment",
    caseAnalysis: "Case Analysis",
    expandingReading: "Extended learning",
    package: "Zip",
    documents: "Document",
    articles: "Article",
    videos: "Video",
    noData: "No relevant training program found",
    noMore: "no more data~",
    categoryPlan: "Category",
    categoryProject: "Category",
    category: "Category",
  },
  courseCentre: {
    // 选修库
    tit: "Optional Courses",
    category: "All Categories",
    category_s: "All",
    sort1: "Latest Release",
    sort2: "Most Popular",
    sort3: "Top Rated",
    h_plan: "Hide your plan",
    minnum: "Minimum optional quantity",
    maxnum: "maximum quantity",
    s_num: "",
    option: "Elective",
    // select: 'Selected',
    select: "Selected",
    limit: "Limit reached",
    limit_p: "limited to",
    resource: "Resource",
    person: "",
    full: "Full",
    not_start: "Not Started",
    close: "Closed",
  },
  courseCentreDetail: {
    // 选修库-计划详情
    tit: "Training Plan",
    time: "Registration time",
    stage1: "Start",
    stage2: "Cancel registration",
    stage3: "Registration not started yet",
    stage4: "Registration full", // Participant number is full
    stage5: "Registration closed",
    stage6: "You have reached the upper limit of course selection",
    details: "Details",
    credits: "Credit",
    credits_d: "",
    duration: "Duration",
    duration_d: "min",
    duration_h: "h",
    course1: "Online Course",
    course2: "Exam",
    course3: "Assignment",
    course4: "Questionnaire",
    course5: "Onsite Training",
    course6: "Reflection",
    course7: "Case Analysis",
    course8: "Extended learning",
    courseDetail: "Course Details",
    courseInfo: "Course Info",
    courseCredit: "Course Credits",
    courseDuration: "Course Duration",
    courseDes: "Course Introduction",
    courseTarget: "Course Objectives",
  },
  sub_index: {
    // 下属辅导
    tit_report: "Subordinate Report",
    tit_homework: "Subordinate Assignment",
    tit_alfx: "Subordinate Case",
    tit_reflect: "Subordinate Reflection",
    tit_do: "Subordinate Drill",
    search: "Search",
    search_plc_r: "Name...",
    search_plc_a: "Login Name、Name...",
    study_status1: "Untutored",
    study_status2: "Tutored",
    study_status3: "Not Submitted",
    study_status4: "All",
    credits: "Details",
    credits_d: "",
    minute: "min",
    twice: "twice",
    preview: "Documents",
    do: "Practice record",
    num: "No.",
    name: "Practice name",
  },
  sub_report: {
    // 下属报表
    study_dur: "Time",
    credit: "Credit",
    noContent: "No Content",
    loading: "loading...",
    noMore: "no more data",
    report: "Self-reflection Report",
    name: "Student Name",
    time: "Submission Time",
    case: "Subordinate case analysis",
  },
  // 实践工具报表
  Practice_tool_report: {
    report: "Practice tool report",
    Item_name: "Item name",
    Student_Name: "Student name",
    Submission_time: "Submission time",
    Case_analysis: "Subordinate case analysis",
  },
  sub_alfx_detail: {
    tit_h: "Assignment",
    tit_a: "Case",
    status: "Status",
    credits: "Credits",
    submit_time: "Submission Time",
    attachment_d: "Attachment Description",
    attachment_ds: "Case Description",
    attachment_ps: "Case Preview",
    attachment_p: "Attachment Preview",
    attachment_s: "Assignment Submitted",
    attachment_ss: "Assignment Submitted",
    feedback: "Feedback",
    pinfen: "Rating",
    feedback_p: "Rating & Feedback",
    submit: "Submit",
    pass_score: "Pass Points",
    not_support:
      "Uploading is currently unsupported. Please log in and operate on your computer.",
    score: "The Points must be less than 3 digits.",
    over: "Your feedback should contain no more than 500 characters.",
  },

  // 调查问卷
  survey: {
    Questionnaire: "Questionnaire",
    Start: "Start",
    SingleChoice: "Single Choice",
    MultipleOptions: "Multiple Choice",
    QA: "Q&A",
    Score: "Points",
    Back: "Previous",
    Next: "Next",
    Submit: "Submit",
    Finished: "Completed",
    InputHere: "Input Here...",
    over: "Expired",
    alerts: "Required fields unfilled or not chosen",
  },
  // 作业墙
  workingWall: {
    AssignmentBBS: "Assignment Display",
    Hottest: "Latest Post",
    MostCommented: "Most Commented",
    MostThumbsUp: "Most Thumbs-up",
    NotSupported: "Not Supported",
    Highestpopularity: " Hottest",
    Comments: "Comment List",
    CommentsDetail: "Comment Details",
    ReplayComment: " Replies",
    Send: "Comment",
    AssignmentDetails: "Assignment Detail",
    Postedat: "Published on:",
    Comment: "Comment List",
    WriteAComment: "Write a comment",
    MoreComments: "More comments",
    Content: "Please key in your comments.(within 512 characters)", // 没翻译
    content: "Please key in your comments.",
    SubmitComments: "Submit a comment",
    zip: "Zip files are only viewable on computers.",
    length: "No Content",
    kong: "Please fill in the comment box",
    over: "Comments should contain no more than 512 characters.",
    add: "Reply added!",
    noMoreData: "no more data~",
    success: "Comment added!",
    // AllAssignment:"All Assignments"
    AssignmentDes: "Assignment description",
    AssignmentSee: "Attachment Preview",
    AssignmentNotSup:
      "Zip files are currently not available on mobiles, please check out on your computer.",
    Enclosure: "Attachment",
    Answer: "Answer",
    more: "more",
    collapse: "close",
    searchTip: "Assignment name/ Student name/ File name",
  },
  // 专栏视频
  columnVideo: {
    Categories: "All Categories",
    All: "All",
    Watched: "Watched",
    more: "more",
    collapse: "close",
    Audio: "Audio",
    seeMore: "More >",
    NoContent: "No Content",
    delete: "Delete",
    success: "Stored",
    del: "Storage cancelled",
    error: "Audio downloading failed",
    noMoreData: "no more data~",
  },
  // 面授课程
  faceCourse: {
    onsiteTraining: "Onsite Training",
    CourseDetails: "Course details",
    LecturerInformation: "Instructor",
    EvaluateTheInstructor: "Evaluate the instructor",
    CourseEvaluation: "Course evaluation",
    OnlineExam: "Online exam",
    LearningTime: "Duration (minutes)",
    min: "min",
    Assessment: "Assessment",
    TeachingTime: "Time",
    TraningLocation: "Location",
    completionStatus: "Completion Status",
    Score: "Points",
    CourseInformation: "Course Information:",
    LecturerEvaluation: "Lecturer Evaluation",
    LeaveAComment: "Please key in your comments.",
    Submit: "Submit",
    MyCommentOn: "My comment on", // 我对xxx的评价
    TeacherOver: "Instructor Assessment has expired",
    CourseOver: "Course Assessment has expired",
    OnlineOver: "Online Test Assessment has expired",
    NoZero: "Points can not be zero",
    success: "Comment added!",
    sign: "Sign in for face-to-face class",
    sign_success: "Signed in",
    click_sign: "Click to sign in",
    sign_user: "Username",
    sign_detail: "Signing in details",
    undone: "Unsigned",
    done: "Signed in",
    waiting: "To sign in",
    unstart: "Wait to start ",
    fen: "",
  },
  // 学习营详情
  LearningCampleDetail: {
    video: "Video",
    expired: "Expired",
    end: "Your course trial has come to the end",
    more: "Click to apply for more course trials",
    clickMore: "Apply for more courses >",
    contents: "Content",
    comment: "Comment",
    Forum: "Forum",
    Notes: "Note",
    NoComment: "No Comment",
    NoQuestions: "No Content",
    Quiz: "Quiz",
    Documents: "Documents",
    IllustrationType: "Illustration",
    Enter: "Enter ",
    Submit: "Comments",
    Write: "Edit comments",
    Posting: "Post",
    writeNotes: "Take notes",
    CompleteAllChapters: "Finish all chapters",
    // 至少学习xxx分钟
    StudyForAtLeast: "study for at least",
    minutes: "minutes",
    CourseExpired: "Courses have expired.",
    TimeOfLearning: "Spent",
    CommentsDetail: "Comment Details",
    CommentsLength: " Replies",
    placeHolder: "Please key in your comments.",
    Send: "Send",
    WriteAComment: "Write a comment",
    ChooseScore: "Please points the course",
    InputHere: "Please key in your comments.(within 512 characters)",
    zero: "Please slide to choose a points",
    one: "Dissatisfied!The course needs to improve",
    three: "OK!The course is fine",
    seven: "Excellent! The course is fabulous!",
    kong: "Please fill in the comment box",
    over: "Your launch should contain no more than 512 characters.",
    success: "Comment added!",
    Instructor: "Instructor",
    delete: "delete",
    QA: "Detailed Answers",
    replayDetail: "Detailed Replies",
    teacher: "(Instructor)",
    add: "Reply added!",
    ReplayPost: "Replies of Posts'",
    Post: "Post",
    PostContent: "Please fill in the comment box",
    overPost: "Your launch should contain no more than 512 characters.",
    addCourse: "success",
    noMore: "no more data~",
    at: "@",
    myNote: "My notes",
    classNote: "Classmates'notes",
    noNote: "No notes yet",
    secret: "Private",
    placeHolderNotes: "Please key in your notes.(within 512 characters)", // Please write your notes
    remb: "submit",
    rembSuccess: "commit added",
    noContent: "No Content",
  },
  dragTest: {
    tit_sin: "Single Choice Drag",
    tit_mul: "Multiple Options Drag",
    tit_sin2: "Single choice matching",
    tit_mul2: "Multiple choice matching",
    answer_w: "Wrong",
    answer_r: "Correct",
    answer: "Correct answer",
    test_feedback: " feedback",
    turn_on: "Turn on",
    turn_off: "Turn off",
    back: "Back",
    next: "Next",
    submit: "Submit",
  },
  // 消息通
  message: {
    Information: "Information detail",
    Message: "Message",
    readed: "Mark all as read",
    unread: "Unread",
    read: "Read",
    watch: "view",
    notification: "Notification",
    myMessage: "My message",
    markAllRead: "Mark all as read",
    clearAll: "Clear all",
    allMessage: "All messages",
    unreads: "Unread",
  },
  advertisement: {
    adsDetail: "Ads detail",
  },
  // 服务协议
  Service: {
    service: "Service Protocols",
    privacy: "Privacy Policy",
    registered:
      "This mobile phone number has been registered, please click 'Enter to study' to login to the platform.",
    domain: "domain:",
    userName: "user name:",
    password: "password:",
    information: "Your account's login info is above.",
    study: "Enter to study",
    yourinfo: "Please offer your information:",
    phone: "Please enter phone number.",
    code: "Please enter verification code",
    codeed: "Obtain the verification code",
    agree: "User's registration means consent",
    services: "《Service Protocols》",
    privacys: "《Privacy Policy》",
    next: "next step",
    repeat: "Please don't click repeatedly.",
    wrong: "invalid phone number",
    reget: "Obtain again",
    sended: "Verification code has been sent.",
    phonenull: "Please enter phone number.",
    codenull: "Verification code cannot be null.",
    submit: "Submit",
    thanks: "Thanks for your feedback!",
    reply: "We will follow your demand!",
    back: "Return & continue your study.",
    company: "Please perfect your company name.",
    name: "Please perfect your name.",
    position: "Please perfect your title.",
    email: "Please perfect your email address.",
    know: "Please tick the way you know it.",
  },
  article: {
    article: "article",
    show: "unfold",
    collapse: "fold",
    suitable: "Adaptable:",
    audio: "audio",
  },
  passwordStrength: {
    weakTips: "8 characters or more",
    moderateTips:
      "8 characters or more，at least two of uppercase letters, lowercase letters, numbers, and symbols",
    strengthTips:
      "8 characters or more，at least three of uppercase letters, lowercase letters, numbers, and symbols",
    maxTips:
      "10 characters or more，at least three of uppercase letters, lowercase letters, numbers, and symbols",
    claim: "Requirements",
    nonCompliance: "Password is not compliant.",
  },
};

export default en;
